import { Pipe, PipeTransform } from '@angular/core';
import { EntityVisibility } from '@src/app/shared/interfaces/base/base-entity.interface';

@Pipe({
  name: 'entitySectionVisibility',
})
export class EntitySectionVisibilityPipe implements PipeTransform {
  transform(
    attributeName: string,
    isCreating: boolean,
    visibility: EntityVisibility
  ): boolean {
    if (isCreating) return true;
    return visibility[attributeName];
  }
}
